/*
 * Copyright (C) 2018 Frontier Developments PLC.
 */

import {Component, Vue} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';
import {ugcItemModule} from '@/store/modules/ugc-item';
import ItemList from '@/components/ItemList/index.vue';
import Loading from '@/components/Loading/index.vue';
import {LoadingState, LoadingStateInterface} from '@/components/Loading/types';
import PageHeader from '@/components/PageHeader/index.vue';
import ProgressStatus from '@/components/ProgressStatus/index.vue';
import {UgcItemInterface} from '@/store/modules/ugc-item/types';
const namespaceUgcItem: string = 'ugcItemModule';
const namespace: string = 'ugcItemModule';

/**
 * Home page view (component).
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
@Component({
    name: 'v-home',
    components: {
        'c-item-list': ItemList,
        'c-loading': Loading,
        'c-page-header': PageHeader,
        'c-progress-status': ProgressStatus,
    },
})
export default class Home extends Vue {
    @Action('loadItems', {namespace}) public loadItems: any;
    @Getter('items', {namespace: namespaceUgcItem}) public items!: UgcItemInterface[];

    public state: LoadingStateInterface = new LoadingState(true, false, 'home.items.loading', 'home.items.error');
    public readonly MAX_ITEMS: number = 25;

    /**
     * Max items getter.
     *
     * @returns {boolean}
     */
    get itemLimitExceeded(): boolean {
        return this.items.length >= this.MAX_ITEMS;
    }

    /**
     * Created life-cycle event.
     */
    public created(): void {
        this.reloadItems();
    }

    /**
     * Reload the user items.
     *
     * @returns {Promise<void>}
     */
    public async reloadItems(): Promise<void> {
        try {
            await this.loadItems();
            this.state.complete();
        } catch (error) {
            this.state.failed();
        }
    }


}
